import styled from "styled-components";

export const Container = styled.div`
  max-width: 90%;
  width: 1142px;
  margin: 0 auto;
  @media (max-width: 768px) {
    width: 100%;
    max-width: 100%;
  }

  .flex {
    .col-left {
      width: 260px;
      @media (max-width: 768px) {
        width: 0;
      }
    }

    .col-right {
      flex: 1;
      .custom-fixed {
        position: sticky;
        top: 80px;
        z-index: 99;
        border-radius: 10px;
        box-shadow: 0px 3px 7px #00000052;
        background-color: lightgray;
        @media (max-width: 1024px) {
          top: 70px;
        }
      }
    }
  }
`;

export const Line = styled.div`
  height: 2px;
  background: #eaeaea;
  margin-top: 5px;
  margin-bottom: 5px;
`;

export const SearchBlock = styled.div`
  padding: 7px 15px;
  input {
    width: 100%;
  }
  .title {
    color: #333333;
    margin-bottom: 10px;
    font-weight: 700;
    font-size: 0.75rem;
  }
  .center-button {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
  }
`;

export const CheckBoxWrap = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  color: #333333;
`;

export const CheckBoxGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  padding: 10px;
  border: 1px solid #dfe4ea;
  border-radius: 10px;
  font-size: 0.75rem;
`;

export const HeadGrButton = styled.div`
  display: flex;
  padding: 10px 20px;
  justify-content: space-between;
  align-items: center;
  .search-count {
    color: #333333;
  }
  .gr-button {
    display: flex;
    align-items: center;
    gap: 10px;
  }
`;

export const SearchResult = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MobileSearch = styled.div`
  position: fixed;
  background-color: #e4e4e4;
  z-index: 99999999;
  top: 0;
  left: 0;
  width: 100vw;
  padding: 50px 0 0 0;
  height: 100svh;
  overflow-y: auto;
  transition: 200ms ease-in-out;

  .close-button {
    float: right;
    margin-right: 20px;
  }
  form {
    margin-top: 20px;
  }
`;
